import { useEffect } from "react"; // eslint-disable-line
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { DateTime } from "luxon";

import firebase from "datastore/database";

const PAX = ["1", "2", "3", "4", "5", "6", "7", "8", "9+"];

const getHash = (date) => {
  let dt = DateTime.fromJSDate(date);
  if (dt.minute < 30) dt = dt.set({ minutes: 0 });
  if (dt.minute >= 30) dt = dt.set({ minutes: 30 });
  // const dateStr = "Fri, 23:00"
  const hash = dt.toFormat("ccc, HH:mm");
  return hash;
};

const getDocIds = () => {
  const now = new Date();
  const hash = getHash(now);
  return PAX.map((partySize) => `${hash}-${partySize}`);
};

const getCurrentTime = () => {
  const now = new Date();
  return now.getHours() * 60 + now.getMinutes(); // Convert current time to minutes
};

const getNextIntervalStartTime = () => {
  const currentMinutes = getCurrentTime();
  const interval = 30; // 30 minutes interval
  const nextIntervalStart = Math.ceil(currentMinutes / interval) * interval; // Round up to the next interval
  return nextIntervalStart;
};

const getRemainingTime = () => {
  const currentMinutes = getCurrentTime();
  const nextIntervalStart = getNextIntervalStartTime();
  const remainingMinutes = nextIntervalStart - currentMinutes;
  const remainingTime = remainingMinutes * 60 * 1000; // Convert remaining minutes to milliseconds
  return remainingTime;
};

export default function useObserveCurrentWaitTime() {
  const dispatch = useDispatch();
  const businessUid = useParams().id;

  useEffect(() => {
    const startListener = async () => {
      const fetchDocuments = async (documentIds) => {
        const documents = [];
        for (const id of documentIds) {
          const docRef = firebase
            .firestore()
            .collection(`wait-times/business/${businessUid}`)
            .doc(id);
          const doc = await docRef.get();
          if (doc.exists) {
            documents.push({ uid: doc.id, ...doc.data() });
          }
        }
        return documents;
      };

      const fetchData = async () => {
        dispatch({ type: "ADD_WAIT_TIME_LOADING" });
        const documentIds = getDocIds();
        const data = await fetchDocuments(documentIds);
        dispatch({ type: "SET_WAIT_TIME", data });
      };

      // Fetch data immediately
      fetchData();

      // // Fetch data every 30 seconds
      // const intervalId = setInterval(fetchData, 30000);

      // Fetch data every 30 minutes
    
      let intervalId = setInterval(() => {
        fetchData();
        const remainingTime = getRemainingTime();
        clearInterval(intervalId);
        setTimeout(() => {
          intervalId = setInterval(() => {
            fetchData();
          }, 30 * 60 * 1000); // Set the interval to 30 minutes after the initial delay
        }, remainingTime);
      }, getRemainingTime());

      return () => clearInterval(intervalId);
    };

    startListener();
  }, [businessUid]);
}
